import { render, staticRenderFns } from "./AppLabel.vue?vue&type=template&id=591a6d05&scoped=true&"
import script from "./AppLabel.vue?vue&type=script&lang=js&"
export * from "./AppLabel.vue?vue&type=script&lang=js&"
import style0 from "./AppLabel.vue?vue&type=style&index=0&id=591a6d05&lang=scss&scoped=true&"
import style1 from "./AppLabel.vue?vue&type=style&index=1&id=591a6d05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591a6d05",
  null
  
)

export default component.exports